import codemark from 'prosemirror-codemark';
import { toggleMark } from 'prosemirror-commands';
import { Plugin } from 'prosemirror-state';
import { createToggleMarkAction } from '../../../utils/actions';
import { withLogAction } from '../../../utils/keymap';
import { CodeSpecs, codeMarkName, codeType } from './CodeSpecs';
import './code.css';
export { codeMarkName, codeType } from './CodeSpecs';
/** @deprecated Use `codeMarkName` instead */
export const code = codeMarkName;
const codeAction = 'code';
export const Code = (builder, opts) => {
    builder.use(CodeSpecs);
    builder.addAction(codeAction, ({ schema }) => createToggleMarkAction(codeType(schema)));
    if (opts === null || opts === void 0 ? void 0 : opts.codeKey) {
        const { codeKey } = opts;
        builder.addKeymap(({ schema }) => ({
            [codeKey]: withLogAction('code_inline', toggleMark(codeType(schema))),
        }));
    }
    builder
        // codemark adds inputRule for `code`,
        // adds fake cursor behaviour when crossing inline_code boundaries,
        // wrap current selected text to inline_code when '`' was pressed.
        // See demo: https://curvenote.github.io/prosemirror-codemark/
        .addPlugin(({ schema }) => codemark({ markType: codeType(schema) }));
    builder.addPlugin(() => 
    // apply codemark when typing text between ``
    new Plugin({
        props: {
            handleTextInput: (view, from, to, text) => {
                var _a, _b, _c, _d;
                const { selection: { $anchor }, tr, schema, } = view.state;
                if (((_b = (_a = $anchor.nodeBefore) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.endsWith('`')) &&
                    ((_d = (_c = $anchor.nodeAfter) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.startsWith('`'))) {
                    view.dispatch(tr.replaceRangeWith(from - 1, to + 1, view.state.schema.text(text, [codeType(schema).create()])));
                    return true;
                }
                return false;
            },
        },
    }));
};
